import { Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
} from "react-hook-form";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";
import WSSelectField from "../../../Components/Select/WSSelect";
import config from "../../../Config/clientConfig.json";

interface UserRoleProps {
  control: Control<any>;
  errors: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
}

const UserRole: React.FC<UserRoleProps> = ({ control, register }) => {
  return (
    <div
      style={{
        padding: "1rem",
        position: "relative",
        margin: "auto",
        marginTop: "4rem",
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <WSTextField
            control={control}
            id="alias"
            {...register("alias")}
            rules={{ required: true }}
            name="alias"
            label="Alias"
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            control={control}
            id="name"
            {...register("name")}
            rules={{ required: false }}
            name="name"
            label="Name"
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12}>
          <WSTextAreaField
            label="Description"
            id="description"
            control={control}
            {...register("description")}
            rules={{ required: true }}
            name="description"
            rows={3}
          />
        </Grid>
        <Grid item xs={12}>
          <WSSelectField
            options={config.userroleconfig.staticOptionData}
            rules={{ required: true }}
            {...register("userrole")}
            id="userrole"
            control={control}
            label="User Role"
            name="userrole"
            labelType="Normal"
          />
        </Grid>
      </Grid>
    </div>
  );
};
export default UserRole;
